import { userConstants } from "../../constant";

export function message(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_MY_MESSAGE:
      return action.message;
    case userConstants.CLEAR_MY_MESSAGE:
      return [];
    default:
      return state;
  }
}
